module.exports = __webpack_public_path__ + "static/media/sample_intro_3.ece34bc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/home/sample_intro_3.jpg
// module id = 1029
// module chunks = 0